import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { NoGames } from '../NoGames/NoGames';

type UnloggedFavouriteGamesProps = {
  namespace: string[];
};

function UnloggedFavouriteGames(props: UnloggedFavouriteGamesProps) {
  const { namespace } = props;

  const t = useTranslations(namespace[0]);
  const t2 = useTranslations(namespace[1]);

  return (
    <div className="flex flex-col items-center gap-5">
      <NoGames
        title={t2('title')}
        paragraph={t2('unlogged_favourite_games.paragraph')}
        buttonText={t('login')}
        buttonHref={ROUTES.LOGIN}
        useLoginRedirect
        data-track-name="Log In"
      />

      <span className="paragraph-strong text-foreground-subtle">
        <span>{t2('unlogged_favourite_games.account_creation_helper')}</span>

        <Link href={ROUTES.REGISTER} className="px-0.5 underline underline-offset-2" data-track-name="Register">
          {t('sign_up')}
        </Link>
      </span>
    </div>
  );
}

export { UnloggedFavouriteGames, type UnloggedFavouriteGamesProps };
